import PropTypes from 'prop-types'
import React, { Component } from 'react'
import { connect } from 'react-redux'

import ErrorModal from '../application/ErrorModal'
import validator from '../../helpers/validator'
import { setAttribute } from '../../actions/registration'
import heartImage from '../../assets/images/heart2.png'
import octoberPinkImage from '../../assets/images/outubrorosa19.png'

const cities = {
  'CAS': 'Cascavel',
  'CTA': 'Curitiba',
  'FOZ': 'Foz do Iguaçu',
  'LDA': 'Londrina',
  'PVI': 'Paranavaí',
  'PGA': 'Ponta Grossa',
}

class HomeStart extends Component {
  constructor(props) {
    super(props)

    this.onCityChange = this.onCityChange.bind(this)
    this.onFormSubmit = this.onFormSubmit.bind(this)
    this.onActionSelect = this.onActionSelect.bind(this)
    this.onActionUnselect = this.onActionUnselect.bind(this)
    this.onOtherChange = this.onOtherChange.bind(this)

    this.state = {
      error: '',
    }
  }

  componentDidMount() {
    if(this.props.city){
      this.setActions(this.props.registration.city)
    }else{
      this.setActions(null)
    }
  }

  setActions(city){
    if(city){
      global.firebase.firestore().collection('doe_seu_tempo_items').where("praca", "==", city).where('faltam', '>', 0).get().then((data) => {
        this.props.setAttribute('actions', data.docs.map(item => {
            return {
              ...item.data(),
              id: item.id
            }
        }))
     })
    }else{
      global.firebase.firestore().collection('doe_seu_tempo_items').where('faltam', '>', 0).get().then((data) => {
        this.props.setAttribute('actions', data.docs.map(item => {
              return {
                ...item.data(),
                id: item.id
              }
        }))
      })
    }
  }

  onCityChange(event) {
    this.props.setAttribute('city', event.currentTarget.value)
    this.setActions(event.currentTarget.value)
  }

  onActionSelect(id) {
    this.props.setAttribute('selectedActions', [
      ...this.props.registration.selectedActions,
      this.props.registration.actions.find(item => (id === item.id))
    ])
  }

  onActionUnselect(id) {
    this.props.setAttribute('selectedActions',
      this.props.registration.selectedActions.filter(item => (id !== item.id))
    )
  }


  onFormSubmit(event) {
    event.preventDefault()

    if (!validator.validateRequired.isValueValid(this.props.registration.selectedActions)) {
      this.setState({
        error: 'Por favor, selecione ao menos uma ação!',
      })
      this.modal.show()
      return
    }

    this.props.setAttribute('start-ok', true)

    this.props.history.push('/step2')
  }

  renderButton(actionID){
    let itemUnselect = this.props.registration.selectedActions.find(item => (actionID === item.id))
    if (itemUnselect) {
      return (
        <div className="col-xs-6">
          <button className="bt select-item selecionado" onClick={() => this.onActionUnselect(itemUnselect.id)}>
            <img src={heartImage} alt="Selecionar" />
            <br /><spam> Selecionado </spam>
          </button>
        </div>
        )
    }
    return (
      <div className="col-xs-6">
        <button className="bt select-item" onClick={() => this.onActionSelect(actionID)}>
          Selecionar <b>ação</b>
        </button>
      </div>
    )
  }

  renderAction(item) {
    return (
      <div key={item.id} className="produto">
        <div className="tit-produto">{item.nome}</div>
        <div className="cidade">{cities[item.praca]}</div>
        <div className="elementos">
          <div className="row">
            <div className="col-xs-6">
              <div className="objetivo">
                <div className="obj"><b>Objetivo:</b>
                  <br />{item.total} horas
                </div>
                <div className="arrec"><b>Arrecadados:</b>
                  <br />{item.doados} horas
                </div>
              </div>
            </div>
            {this.renderButton(item.id)}
          </div>
        </div>
      </div>
    )
  }

  getActions() {
    return this.props.registration.actions.map(this.renderAction.bind(this))
  }

  onOtherChange(event) {
    const item = this.props.registration.selectedActions.find((item) => {
      return item.id === 'outro'
    })

    const newItem = {
      ...item,
      ativo: true,
      doados: 0,
      doado: 0,
      faltam: 0,
      nome: event.currentTarget.value,
      praca: 'DEFAULT',
      registro: null,
      total: 0,
      id: 'outro'
    }

    const index = this.props.registration.selectedActions.findIndex((item) => {
      return (item.id === 'outro')
    })

    const selectedActions = this.props.registration.selectedActions

    if (event.currentTarget.value.length > 0){
      if (index === -1) {
        this.props.setAttribute('selectedActions', [
          ...selectedActions,
          newItem,
        ])
      } else {
        this.props.setAttribute('selectedActions', [
          ...selectedActions.slice(0, index),
          newItem,
          ...selectedActions.slice(index + 1),
        ])
      }
    } else {
      this.onActionUnselect('outro')
    }
  }

  render() {
    return (
      <div>
        <div className="topo-vovo">
          <img src={octoberPinkImage} alt="Doe seu Tempo"/>
        </div>
        <div className="tit-campanha">
          Neste Outubro Rosa, lembrar é cuidar
        </div>
        <div className="text-campanha">
          <div className="container">
            <p>
              Sabe aquela sensação boa que dá quando pensamos no bem do próximo e sentimos que cuidamos de nós mesmos ao oferecer para alguém aquilo que temos de melhor?
              É incrível, muito poderoso e todo mundo sai ganhando!
            </p>
            <p>
              Por isso, te convidamos, neste Outubro, a ajudar ONGs que prestam assistência a mulheres com câncer de mama aqui no Paraná.
              Elas dependem muito do trabalho voluntário de pessoas ao longo do ano, que, assim como você,
              têm habilidades e talentos maravilhosos para compartilhar com aquelas que mais precisam ❤
            </p>
          </div>
        </div>
        <div className="box-como-ajudar">
          <div className="container">
            <div className="title-como-ajudar">Como ajudar</div>
            <div className="passos">
              <div className="passo">
                <div className="num-passo">1</div>
                <div className="text-passo"> Selecione a <b>cidade</b> em que você deseja realizar o voluntariado</div>
              </div>

              <div className="passo">
                <div className="num-passo">2</div>
                <div className="text-passo"> Escolha abaixo a <b>ação</b> que você gostaria de prestar</div>
              </div>

              <div className="passo"><span className="num-passo">3</span>
                <span className="text-passo">Clique em <b>"Quero ajudar"</b>
                </span>
              </div>

              <div className="passo"><span className="num-passo">4</span>
                <span className="text-passo">Preencha o formulário, selecionando a quantidade de horas que você pode oferecer
                </span>
              </div>

              <div className="passo"><span className="num-passo">5</span>
                <span className="text-passo">Clique em <b>"Tudo ok! Vamos continuar"</b> para enviar o formulário e concluir a inscrição
                </span>
              </div>
              <div className="passo">
                <span className="num-passo">6</span>
                <span className="text-passo">Pode relaxar e lembrar de cuidar muuuito de você mesmo também. A partir de novembro, uma ONG entrará em contato :)
                </span>
              </div>
            </div>
          </div>
        </div>
        <div className="bordinha"></div>
        <div className="lista-itens">
          <div className="container">
            <div className="row">
              <div className="col-md-12">
                <div className="title-lista">Confira as ações que você pode oferecer</div>
                <div className="busca">
                  <select
                    ref={(ref) => { this.city = ref }}
                    className="form-control required"
                    onChange={this.onCityChange}
                    defaultValue=""
                    value={this.props.registration.city}>
                    <option value="">Todas as cidades</option>
                    <option value='CAS'>Cascavel</option>
                    <option value='CTA'>Curitiba</option>
                    <option value='FOZ'>Foz do Iguaçu</option>
                    <option value='LDA'>Londrina</option>
                    <option value='PVI'>Paranavaí</option>
                    <option value='PGA'>Ponta Grossa</option>
                  </select>
                </div>
              </div>
              <div className="col-md-12">
                <div className="lista-produtos">
                  {this.getActions()}
                </div>
              </div>
            </div>
          </div>
        </div>
        <div className="bt-fechar-tudo homefechar">
          <div className="container">
            <button className="bt fecharpedido" onClick={this.onFormSubmit}>Quero ajudar <img src={heartImage} alt="Coração" /></button>
          </div>
          </div>

        <ErrorModal
          ref={(ref) => { this.modal = ref }}
          message={this.state.error}
        />
      </div>
    )
  }
}

HomeStart.propTypes = {
  history: PropTypes.shape({
    push: PropTypes.func.isRequired,
  }),
  setAttribute: PropTypes.func.isRequired,
}

HomeStart.defaultProps = {
  history: {
    push: () => { },
  },
}

const mapStateToProps = state => ({
  registration: state.registration,
})

const mapDispatchToProps = {
  setAttribute,
}

export default connect(mapStateToProps, mapDispatchToProps)(HomeStart)



// WEBPACK FOOTER //
// ./src/components/home/Start.js